
(function(){
  var slides=document.querySelectorAll('#stage .slide'), btns=document.querySelectorAll('#thumbs button');
  btns.forEach(function(b,i){b.addEventListener('click',function(){
    slides.forEach(function(s){s.classList.remove('on')});
    btns.forEach(function(x){x.classList.remove('on')});
    slides[i].classList.add('on'); b.classList.add('on');});});
  var bar=document.getElementById('bar'), box=document.querySelector('.pricebox');
  (document.querySelector('.ccv')||document.body).classList.add('has-bar');
  function onScroll(){ bar.classList.toggle('on', box.getBoundingClientRect().bottom<0); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  var targets=document.querySelectorAll('section .head, .split>div, .split>img, .card, .step, .spec, .mat, .faq, .band .txt, .place');
  targets.forEach(function(t){t.classList.add('rv')});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.06});
    targets.forEach(function(t){io.observe(t)});
  } else { targets.forEach(function(t){t.classList.add('in')}); }
})();
